import { useCallback } from 'react';

import { Stack, Button, TextField, InputAdornment } from '@mui/material';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

export interface ToolbarOptions {
  addButton: boolean;
}

export type Props = {
  options?: ToolbarOptions | undefined;
  onFilters?: (value: string) => void;
  onAddList?: VoidFunction;
};

export default function ListsTableToolbar({
  options = { addButton: true },
  onFilters,
  onAddList = () => { },
}: Props) {

  const { t } = useTranslate();

  const handleFilterName = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      onFilters ? onFilters(event.target.value) : null,
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        sm: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
        width: '100%',
      }}
    >
      {onFilters && (
        <TextField
          onChange={handleFilterName}
          placeholder="Search..."
          name="description"
          sx={{
            minWidth: {
              xs: '100%',
              sm: '360px',
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      )}
      <Stack
        sx={{ width: '100%' }}
        direction="row"
        justifyContent="flex-end"
        spacing={2}
        flexGrow={1}
      >
        {options.addButton && (
          <Button
            sx={{ width: { xs: '100%', sm: '150px' }, maxHeight: 36 }}
            size="medium"
            startIcon={<Iconify icon="material-symbols:add" />}
            variant="contained"
            onClick={onAddList}
          >
            {t(`lists.actions.add`)}
          </Button>
        )}
      </Stack>

    </Stack>
  );
}
